import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { atom } from 'jotai';
import { createContext } from 'react';

import { marketsBunja } from '@flipster/socket/r230522/market';
import { spotMarketsBunja } from '@flipster/socket/r230522/spot-market';

import { rawInstrumentsKeyBySymbolAtom, snapshotSpecBunja } from '../snapshot/state';
import { symbolsQueryAtom } from '../symbol/symbols';

export const SymbolContext = createContext<string>(null as unknown as string);
export const SymbolScope = createScopeFromContext(SymbolContext);

export const zeroSpreadSymbolsBunja = bunja(() => {
  const zeroSpreadSymbolsAtom = atom((get) => {
    const symbols = get(symbolsQueryAtom);
    if (!symbols.data) return [];
    return symbols.data.data.zeroSpread;
  });

  const isLoadingAtom = atom((get) => get(symbolsQueryAtom).isLoading);

  return {
    zeroSpreadSymbolsAtom,
    isLoadingAtom,
  };
});
zeroSpreadSymbolsBunja.debugLabel = 'zeroSpreadSymbolsBunja';

export const symbolButtonBunja = bunja(() => {
  const symbol = bunja.use(SymbolScope);
  const { marketsAtom } = bunja.use(marketsBunja);
  const { spotMarketsAtom } = bunja.use(spotMarketsBunja);
  const { instrumentsKeyBySymbolAtom } = bunja.use(snapshotSpecBunja);

  const tickersAtom = atom((get) => {
    const markets = get(marketsAtom);
    const spotMarkets = get(spotMarketsAtom);
    return { ...markets, ...spotMarkets };
  });

  const symbolInfoAtom = atom((get) => get(tickersAtom)[symbol]);
  const maxLeverageHardLimitAtom = atom((get) => get(instrumentsKeyBySymbolAtom)?.[symbol]?.maxLeverageHardLimit ?? 1);
  const maxInitLeverageIsolatedMarginAtom = atom(
    (get) => get(instrumentsKeyBySymbolAtom)?.[symbol]?.maxInitLeverageIsolatedMargin,
  );
  const pricePrecisionAtom = atom((get) => {
    const keyBySymbols = get(rawInstrumentsKeyBySymbolAtom);
    return keyBySymbols?.[symbol].pricePrecision;
  });
  return {
    symbolInfoAtom,
    pricePrecisionAtom,
    maxLeverageHardLimitAtom,
    maxInitLeverageIsolatedMarginAtom,
  };
});
symbolButtonBunja.debugLabel = 'symbolButtonBunja';
